/**
 * Les trois états d'un écran qui attend des données : il charge, il a échoué,
 * ou il n'a rien à montrer.
 *
 * **Le troisième est le plus souvent bâclé.** « Aucune source dans cette
 * catégorie » ne suffit pas : il faut dire quoi faire ensuite, sinon
 * l'utilisateur conclut que quelque chose est cassé. La maquette l'avait vu —
 * « Ajoutez un fichier depuis OneDrive pour démarrer. »
 */
import type { ReactNode } from "react";

export function Chargement({ lignes = 3 }: { lignes?: number }) {
  return (
    <div className="pile pile--serree" aria-busy="true" aria-live="polite">
      <span className="faible">Chargement…</span>
      {Array.from({ length: lignes }, (_, rang) => (
        <div key={rang} className="squelette" style={{ width: `${100 - rang * 12}%` }} />
      ))}
    </div>
  );
}

export function Echec({ erreur, reessayer }: { erreur: unknown; reessayer?: () => void }) {
  const message = erreur instanceof Error ? erreur.message : String(erreur);
  return (
    <div className="avis avis--erreur" role="alert">
      <div className="pile pile--serree" style={{ flex: 1 }}>
        <strong>Cette information n'a pas pu être chargée.</strong>
        <span className="discret">{message}</span>
      </div>
      {reessayer && (
        <button type="button" className="bouton" onClick={reessayer}>
          Réessayer
        </button>
      )}
    </div>
  );
}

export function Vide({ titre, aide, action }: { titre: string; aide?: string; action?: ReactNode }) {
  return (
    <div className="tableau__vide">
      <div className="pile pile--serree" style={{ alignItems: "center" }}>
        <strong>{titre}</strong>
        {aide && <span className="discret">{aide}</span>}
        {action}
      </div>
    </div>
  );
}
